/**
 * Lazy-loaded page components for better performance and code splitting
 * This file centralizes all lazy imports and provides consistent loading behavior
 */
import { lazy } from 'react'

// Lazy load all main pages for code splitting using path aliases
export const LazyHomePage = lazy(() => import('@pages/HomePage'))

export const LazySurveyPage = lazy(() =>
  import('@pages/SurveyPage').then(module => ({
    default: module.default,
  }))
)

export const LazySurveyReviewPage = lazy(() =>
  import('@pages/SurveyReviewPage').then(module => ({
    default: module.default,
  }))
)

export const LazyCompletePage = lazy(() =>
  import('@/pages/CompletePage/CompletePage').then(module => ({
    default: module.default,
  }))
)

export const LazyErrorPage = lazy(() =>
  import('@pages/Errors/Common').then(module => ({
    default: module.default,
  }))
)

export const LazyPageNotFound = lazy(() =>
  import('@pages/Errors/PageNotFound').then(module => ({
    default: module.default,
  }))
)

// Lazy load route guards
export const LazyHomePageGuard = lazy(() =>
  import('@components/RouteGuard/HomePageGuard').then(module => ({
    default: module.default,
  }))
)

// Pre-load critical routes after initial load
export const preloadCriticalRoutes = (): void => {
  // Pre-load survey page as it's likely to be accessed next
  setTimeout(() => {
    import('@pages/SurveyPage')
    import('@pages/SurveyReviewPage')
  }, 2000) // Pre-load after 2 seconds
}
